// THIS FILE IS GENERATED - DO NOT EDIT
// To re-generate run ./scripts/generate_emoji_data.js
export default {
  100: '💯',
  1234: '🔢',
  regional_indicator_a: '🇦',
  regional_indicator_b: '🇧',
  regional_indicator_c: '🇨',
  regional_indicator_d: '🇩',
  regional_indicator_e: '🇪',
  regional_indicator_f: '🇫',
  regional_indicator_g: '🇬',
  regional_indicator_h: '🇭',
  regional_indicator_i: '🇮',
  regional_indicator_j: '🇯',
  regional_indicator_k: '🇰',
  regional_indicator_l: '🇱',
  regional_indicator_m: '🇲',
  regional_indicator_n: '🇳',
  regional_indicator_o: '🇴',
  regional_indicator_p: '🇵',
  regional_indicator_q: '🇶',
  regional_indicator_r: '🇷',
  regional_indicator_s: '🇸',
  regional_indicator_t: '🇹',
  regional_indicator_u: '🇺',
  regional_indicator_v: '🇻',
  regional_indicator_w: '🇼',
  regional_indicator_x: '🇽',
  regional_indicator_y: '🇾',
  regional_indicator_z: '🇿',
  grinning: '😀',
  grinning_face: '😀',
  grinning_face_with_big_eyes: '😃',
  smiley: '😃',
  grinning_face_with_closed_eyes: '😄',
  smile: '😄',
  beaming_face: '😁',
  grin: '😁',
  laughing: '😆',
  lol: '😆',
  satisfied: '😆',
  squinting_face: '😆',
  grinning_face_with_sweat: '😅',
  sweat_smile: '😅',
  rofl: '🤣',
  joy: '😂',
  lmao: '😂',
  tears_of_joy: '😂',
  slightly_smiling_face: '🙂',
  upside_down_face: '🙃',
  melt: '🫠',
  melting_face: '🫠',
  wink: '😉',
  winking_face: '😉',
  blush: '😊',
  smiling_face_with_closed_eyes: '😊',
  halo: '😇',
  innocent: '😇',
  smiling_face_with_3_hearts: '🥰',
  heart_eyes: '😍',
  smiling_face_with_heart_eyes: '😍',
  star_struck: '🤩',
  blowing_a_kiss: '😘',
  kissing_heart: '😘',
  kissing: '😗',
  kissing_face: '😗',
  relaxed: '☺️',
  smiling_face: '☺️',
  kissing_closed_eyes: '😚',
  kissing_face_with_closed_eyes: '😚',
  kissing_face_with_smiling_eyes: '😙',
  kissing_smiling_eyes: '😙',
  smiling_face_with_tear: '🥲',
  savoring_food: '😋',
  yum: '😋',
  face_with_tongue: '😛',
  stuck_out_tongue: '😛',
  stuck_out_tongue_winking_eye: '😜',
  zany: '🤪',
  zany_face: '🤪',
  stuck_out_tongue_closed_eyes: '😝',
  money_mouth_face: '🤑',
  hug: '🤗',
  hugging: '🤗',
  hugging_face: '🤗',
  face_with_hand_over_mouth: '🤭',
  hand_over_mouth: '🤭',
  face_with_open_eyes_hand_over_mouth: '🫢',
  gasp: '🫢',
  face_with_peeking_eye: '🫣',
  peek: '🫣',
  shush: '🤫',
  shushing_face: '🤫',
  thinking: '🤔',
  thinking_face: '🤔',
  wtf: '🤔',
  salute: '🫡',
  saluting_face: '🫡',
  zipper_mouth: '🤐',
  zipper_mouth_face: '🤐',
  face_with_raised_eyebrow: '🤨',
  raised_eyebrow: '🤨',
  neutral: '😐️',
  neutral_face: '😐️',
  expressionless: '😑',
  expressionless_face: '😑',
  no_mouth: '😶',
  dotted_line_face: '🫥',
  in_clouds: '😶‍🌫️',
  smirk: '😏',
  smirking: '😏',
  smirking_face: '😏',
  unamused: '😒',
  unamused_face: '😒',
  rolling_eyes: '🙄',
  grimacing: '😬',
  grimacing_face: '😬',
  exhale: '😮‍💨',
  exhaling: '😮‍💨',
  lying: '🤥',
  lying_face: '🤥',
  shaking: '🫨',
  shaking_face: '🫨',
  head_shaking_horizontally: '🙂‍↔️',
  head_shaking_vertically: '🙂‍↕️',
  relieved: '😌',
  relieved_face: '😌',
  pensive: '😔',
  pensive_face: '😔',
  sleepy: '😪',
  sleepy_face: '😪',
  drooling: '🤤',
  drooling_face: '🤤',
  sleeping: '😴',
  sleeping_face: '😴',
  face_with_eye_bags: '🫩',
  mask: '😷',
  medical_mask: '😷',
  face_with_thermometer: '🤒',
  face_with_head_bandage: '🤕',
  nauseated: '🤢',
  nauseated_face: '🤢',
  face_vomiting: '🤮',
  vomiting: '🤮',
  sneezing: '🤧',
  sneezing_face: '🤧',
  hot: '🥵',
  hot_face: '🥵',
  cold: '🥶',
  cold_face: '🥶',
  woozy: '🥴',
  woozy_face: '🥴',
  dizzy_face: '😵',
  knocked_out: '😵',
  dizzy_eyes: '😵‍💫',
  exploding_head: '🤯',
  cowboy: '🤠',
  cowboy_face: '🤠',
  hooray: '🥳',
  partying: '🥳',
  partying_face: '🥳',
  disguised: '🥸',
  disguised_face: '🥸',
  smiling_face_with_sunglasses: '😎',
  sunglasses_cool: '😎',
  too_cool: '😎',
  nerd: '🤓',
  nerd_face: '🤓',
  face_with_monocle: '🧐',
  confused: '😕',
  confused_face: '😕',
  face_with_diagonal_mouth: '🫤',
  worried: '😟',
  worried_face: '😟',
  slightly_frowning_face: '🙁',
  white_frowning_face: '☹️',
  face_with_open_mouth: '😮',
  open_mouth: '😮',
  hushed: '😯',
  hushed_face: '😯',
  astonished: '😲',
  astonished_face: '😲',
  flushed: '😳',
  flushed_face: '😳',
  distorted_face: '🫪',
  pleading: '🥺',
  pleading_face: '🥺',
  face_holding_back_tears: '🥹',
  watery_eyes: '🥹',
  frowning: '😦',
  frowning_face: '😦',
  anguished: '😧',
  anguished_face: '😧',
  fearful: '😨',
  fearful_face: '😨',
  anxious: '😰',
  anxious_face: '😰',
  cold_sweat: '😰',
  disappointed_relieved: '😥',
  sad_relieved_face: '😥',
  cry: '😢',
  crying_face: '😢',
  loudly_crying_face: '😭',
  sob: '😭',
  scream: '😱',
  screaming_in_fear: '😱',
  confounded: '😖',
  confounded_face: '😖',
  persevere: '😣',
  persevering_face: '😣',
  disappointed: '😞',
  disappointed_face: '😞',
  downcast_face: '😓',
  sweat: '😓',
  weary: '😩',
  weary_face: '😩',
  tired: '😫',
  tired_face: '😫',
  yawn: '🥱',
  yawning: '🥱',
  yawning_face: '🥱',
  nose_steam: '😤',
  triumph: '😤',
  pout: '😡',
  pouting_face: '😡',
  rage: '😡',
  angry: '😠',
  angry_face: '😠',
  censored: '🤬',
  face_with_symbols_on_mouth: '🤬',
  smiling_imp: '😈',
  angry_imp: '👿',
  imp: '👿',
  skull: '💀',
  skull_and_crossbones: '☠️',
  poop: '💩',
  shit: '💩',
  clown: '🤡',
  clown_face: '🤡',
  japanese_ogre: '👹',
  ogre: '👹',
  goblin: '👺',
  japanese_goblin: '👺',
  ghost: '👻',
  alien: '👽️',
  alien_monster: '👾',
  space_invader: '👾',
  robot: '🤖',
  robot_face: '🤖',
  grinning_cat: '😺',
  smiley_cat: '😺',
  grinning_cat_with_closed_eyes: '😸',
  smile_cat: '😸',
  joy_cat: '😹',
  tears_of_joy_cat: '😹',
  heart_eyes_cat: '😻',
  smiling_cat_with_heart_eyes: '😻',
  smirk_cat: '😼',
  wry_smile_cat: '😼',
  kissing_cat: '😽',
  scream_cat: '🙀',
  weary_cat: '🙀',
  crying_cat: '😿',
  pouting_cat: '😾',
  see_no_evil: '🙈',
  hear_no_evil: '🙉',
  speak_no_evil: '🙊',
  love_letter: '💌',
  cupid: '💘',
  heart_with_arrow: '💘',
  gift_heart: '💝',
  heart_with_ribbon: '💝',
  sparkling_heart: '💖',
  growing_heart: '💗',
  heartpulse: '💗',
  beating_heart: '💓',
  heartbeat: '💓',
  revolving_hearts: '💞',
  two_hearts: '💕',
  heart_decoration: '💟',
  heart_exclamation: '❣️',
  broken_heart: '💔',
  heart_on_fire: '❤️‍🔥',
  mending_heart: '❤️‍🩹',
  heart: '❤️',
  red_heart: '❤️',
  pink_heart: '🩷',
  orange_heart: '🧡',
  yellow_heart: '💛',
  green_heart: '💚',
  blue_heart: '💙',
  light_blue_heart: '🩵',
  purple_heart: '💜',
  brown_heart: '🤎',
  black_heart: '🖤',
  gray_heart: '🩶',
  grey_heart: '🩶',
  white_heart: '🤍',
  kiss: '💋',
  anger: '💢',
  fight_cloud: '🫯',
  boom: '💥',
  collision: '💥',
  dizzy: '💫',
  sweat_drops: '💦',
  dash: '💨',
  dashing_away: '💨',
  hole: '🕳️',
  speech_balloon: '💬',
  eye_in_speech_bubble: '👁️‍🗨️',
  left_speech_bubble: '🗨️',
  right_anger_bubble: '🗯️',
  thought_balloon: '💭',
  zzz: '💤',
  wave: '👋',
  waving_hand: '👋',
  raised_back_of_hand: '🤚',
  raised_hand_with_fingers_splayed: '🖐️',
  high_five: '✋️',
  raised_hand: '✋️',
  vulcan: '🖖',
  rightwards_hand: '🫱',
  leftwards_hand: '🫲',
  palm_down: '🫳',
  palm_up: '🫴',
  leftwards_pushing_hand: '🫷',
  rightwards_pushing_hand: '🫸',
  ok_hand: '👌',
  pinch: '🤌',
  pinched_fingers: '🤌',
  pinching_hand: '🤏',
  v: '✌️',
  victory: '✌️',
  fingers_crossed: '🤞',
  hand_with_index_finger_and_thumb_crossed: '🫰',
  love_you_gesture: '🤟',
  metal: '🤘',
  sign_of_the_horns: '🤘',
  call_me_hand: '🤙',
  point_left: '👈️',
  point_right: '👉️',
  point_up: '👆️',
  middle_finger: '🖕',
  point_down: '👇️',
  point_up_2: '☝️',
  point_forward: '🫵',
  '+1': '👍️',
  thumbsup: '👍️',
  yes: '👍️',
  '-1': '👎️',
  no: '👎️',
  thumbsdown: '👎️',
  fist: '✊️',
  punch: '👊',
  left_facing_fist: '🤛',
  right_facing_fist: '🤜',
  clap: '👏',
  clapping_hands: '👏',
  raised_hands: '🙌',
  heart_hands: '🫶',
  open_hands: '👐',
  palms_up_together: '🤲',
  handshake: '🤝',
  folded_hands: '🙏',
  pray: '🙏',
  writing_hand: '✍️',
  nail_care: '💅',
  nail_polish: '💅',
  selfie: '🤳',
  muscle: '💪',
  right_bicep: '💪',
  mechanical_arm: '🦾',
  mechanical_leg: '🦿',
  leg: '🦵',
  foot: '🦶',
  ear: '👂️',
  ear_with_hearing_aid: '🦻',
  hearing_aid: '🦻',
  nose: '👃',
  brain: '🧠',
  anatomical_heart: '🫀',
  lungs: '🫁',
  tooth: '🦷',
  bone: '🦴',
  eyes: '👀',
  eye: '👁️',
  tongue: '👅',
  lips: '👄',
  mouth: '👄',
  biting_lip: '🫦',
  baby: '👶',
  child: '🧒',
  boy: '👦',
  girl: '👧',
  adult: '🧑',
  blond_haired: '👱',
  man: '👨',
  person_bearded: '🧔',
  man_bearded: '🧔‍♂️',
  woman_bearded: '🧔‍♀️',
  man_red_haired: '👨‍🦰',
  man_curly_haired: '👨‍🦱',
  man_white_haired: '👨‍🦳',
  man_bald: '👨‍🦲',
  woman: '👩',
  woman_red_haired: '👩‍🦰',
  red_haired: '🧑‍🦰',
  woman_curly_haired: '👩‍🦱',
  curly_haired: '🧑‍🦱',
  woman_white_haired: '👩‍🦳',
  white_haired: '🧑‍🦳',
  woman_bald: '👩‍🦲',
  bald: '🧑‍🦲',
  woman_blond_haired: '👱‍♀️',
  man_blond_haired: '👱‍♂️',
  older_adult: '🧓',
  older_man: '👴',
  older_woman: '👵',
  person_frowning: '🙍',
  man_frowning: '🙍‍♂️',
  woman_frowning: '🙍‍♀️',
  person_pouting: '🙎',
  pouting: '🙎',
  man_pouting: '🙎‍♂️',
  woman_pouting: '🙎‍♀️',
  no_good: '🙅',
  person_gesturing_no: '🙅',
  man_gesturing_no: '🙅‍♂️',
  woman_gesturing_no: '🙅‍♀️',
  all_good: '🙆',
  person_gesturing_ok: '🙆',
  man_gesturing_ok: '🙆‍♂️',
  woman_gesturing_ok: '🙆‍♀️',
  person_tipping_hand: '💁',
  man_tipping_hand: '💁‍♂️',
  woman_tipping_hand: '💁‍♀️',
  person_raising_hand: '🙋',
  man_raising_hand: '🙋‍♂️',
  woman_raising_hand: '🙋‍♀️',
  deaf_person: '🧏',
  deaf_man: '🧏‍♂️',
  deaf_woman: '🧏‍♀️',
  bow: '🙇',
  person_bowing: '🙇',
  man_bowing: '🙇‍♂️',
  woman_bowing: '🙇‍♀️',
  facepalm: '🤦',
  person_facepalming: '🤦',
  man_facepalming: '🤦‍♂️',
  woman_facepalming: '🤦‍♀️',
  person_shrugging: '🤷',
  shrug: '🤷',
  man_shrugging: '🤷‍♂️',
  woman_shrugging: '🤷‍♀️',
  health_worker: '🧑‍⚕️',
  man_health_worker: '👨‍⚕️',
  woman_health_worker: '👩‍⚕️',
  student: '🧑‍🎓',
  man_student: '👨‍🎓',
  woman_student: '👩‍🎓',
  teacher: '🧑‍🏫',
  man_teacher: '👨‍🏫',
  woman_teacher: '👩‍🏫',
  judge: '🧑‍⚖️',
  man_judge: '👨‍⚖️',
  woman_judge: '👩‍⚖️',
  farmer: '🧑‍🌾',
  man_farmer: '👨‍🌾',
  woman_farmer: '👩‍🌾',
  cook: '🧑‍🍳',
  man_cook: '👨‍🍳',
  woman_cook: '👩‍🍳',
  mechanic: '🧑‍🔧',
  man_mechanic: '👨‍🔧',
  woman_mechanic: '👩‍🔧',
  factory_worker: '🧑‍🏭',
  man_factory_worker: '👨‍🏭',
  woman_factory_worker: '👩‍🏭',
  office_worker: '🧑‍💼',
  man_office_worker: '👨‍💼',
  woman_office_worker: '👩‍💼',
  scientist: '🧑‍🔬',
  man_scientist: '👨‍🔬',
  woman_scientist: '👩‍🔬',
  technologist: '🧑‍💻',
  man_technologist: '👨‍💻',
  woman_technologist: '👩‍💻',
  singer: '🧑‍🎤',
  man_singer: '👨‍🎤',
  woman_singer: '👩‍🎤',
  artist: '🧑‍🎨',
  man_artist: '👨‍🎨',
  woman_artist: '👩‍🎨',
  pilot: '🧑‍✈️',
  man_pilot: '👨‍✈️',
  woman_pilot: '👩‍✈️',
  astronaut: '🧑‍🚀',
  man_astronaut: '👨‍🚀',
  woman_astronaut: '👩‍🚀',
  firefighter: '🧑‍🚒',
  man_firefighter: '👨‍🚒',
  woman_firefighter: '👩‍🚒',
  cop: '👮',
  police_officer: '👮',
  man_police_officer: '👮‍♂️',
  woman_police_officer: '👮‍♀️',
  detective: '🕵️',
  man_detective: '🕵️‍♂️',
  woman_detective: '🕵️‍♀️',
  guard: '💂',
  man_guard: '💂‍♂️',
  woman_guard: '💂‍♀️',
  ninja: '🥷',
  construction_worker: '👷',
  man_construction_worker: '👷‍♂️',
  woman_construction_worker: '👷‍♀️',
  person_with_crown: '🫅',
  royalty: '🫅',
  prince: '🤴',
  princess: '👸',
  person_wearing_turban: '👳',
  man_wearing_turban: '👳‍♂️',
  woman_wearing_turban: '👳‍♀️',
  person_with_skullcap: '👲',
  woman_with_headscarf: '🧕',
  person_in_tuxedo: '🤵',
  man_in_tuxedo: '🤵‍♂️',
  woman_in_tuxedo: '🤵‍♀️',
  person_with_veil: '👰',
  man_with_veil: '👰‍♂️',
  woman_with_veil: '👰‍♀️',
  pregnant_woman: '🤰',
  pregnant_man: '🫃',
  pregnant_person: '🫄',
  breast_feeding: '🤱',
  woman_feeding_baby: '👩‍🍼',
  man_feeding_baby: '👨‍🍼',
  person_feeding_baby: '🧑‍🍼',
  angel: '👼',
  santa: '🎅',
  mrs_claus: '🤶',
  mx_claus: '🧑‍🎄',
  superhero: '🦸',
  man_superhero: '🦸‍♂️',
  woman_superhero: '🦸‍♀️',
  supervillain: '🦹',
  man_supervillain: '🦹‍♂️',
  woman_supervillain: '🦹‍♀️',
  mage: '🧙',
  man_mage: '🧙‍♂️',
  woman_mage: '🧙‍♀️',
  fairy: '🧚',
  man_fairy: '🧚‍♂️',
  woman_fairy: '🧚‍♀️',
  vampire: '🧛',
  man_vampire: '🧛‍♂️',
  woman_vampire: '🧛‍♀️',
  merperson: '🧜',
  merman: '🧜‍♂️',
  mermaid: '🧜‍♀️',
  elf: '🧝',
  man_elf: '🧝‍♂️',
  woman_elf: '🧝‍♀️',
  genie: '🧞',
  man_genie: '🧞‍♂️',
  woman_genie: '🧞‍♀️',
  zombie: '🧟',
  man_zombie: '🧟‍♂️',
  woman_zombie: '🧟‍♀️',
  troll: '🧌',
  hairy_creature: '🫈',
  massage: '💆',
  person_getting_massage: '💆',
  man_getting_massage: '💆‍♂️',
  woman_getting_massage: '💆‍♀️',
  haircut: '💇',
  person_getting_haircut: '💇',
  man_getting_haircut: '💇‍♂️',
  woman_getting_haircut: '💇‍♀️',
  person_walking: '🚶',
  walking: '🚶',
  man_walking: '🚶‍♂️',
  woman_walking: '🚶‍♀️',
  person_walking_right: '🚶‍➡️',
  woman_walking_right: '🚶‍♀️‍➡️',
  man_walking_right: '🚶‍♂️‍➡️',
  person_standing: '🧍',
  standing: '🧍',
  man_standing: '🧍‍♂️',
  woman_standing: '🧍‍♀️',
  kneeling: '🧎',
  person_kneeling: '🧎',
  man_kneeling: '🧎‍♂️',
  woman_kneeling: '🧎‍♀️',
  person_kneeling_right: '🧎‍➡️',
  woman_kneeling_right: '🧎‍♀️‍➡️',
  man_kneeling_right: '🧎‍♂️‍➡️',
  person_with_probing_cane: '🧑‍🦯',
  person_with_white_cane: '🧑‍🦯',
  person_with_white_cane_right: '🧑‍🦯‍➡️',
  man_with_probing_cane: '👨‍🦯',
  man_with_white_cane: '👨‍🦯',
  man_with_white_cane_right: '👨‍🦯‍➡️',
  woman_with_probing_cane: '👩‍🦯',
  woman_with_white_cane: '👩‍🦯',
  woman_with_white_cane_right: '👩‍🦯‍➡️',
  person_in_motorized_wheelchair: '🧑‍🦼',
  person_in_motorized_wheelchair_right: '🧑‍🦼‍➡️',
  man_in_motorized_wheelchair: '👨‍🦼',
  man_in_motorized_wheelchair_right: '👨‍🦼‍➡️',
  woman_in_motorized_wheelchair: '👩‍🦼',
  woman_in_motorized_wheelchair_right: '👩‍🦼‍➡️',
  person_in_manual_wheelchair: '🧑‍🦽',
  person_in_manual_wheelchair_right: '🧑‍🦽‍➡️',
  man_in_manual_wheelchair: '👨‍🦽',
  man_in_manual_wheelchair_right: '👨‍🦽‍➡️',
  woman_in_manual_wheelchair: '👩‍🦽',
  woman_in_manual_wheelchair_right: '👩‍🦽‍➡️',
  person_running: '🏃',
  running: '🏃',
  man_running: '🏃‍♂️',
  woman_running: '🏃‍♀️',
  person_running_right: '🏃‍➡️',
  woman_running_right: '🏃‍♀️‍➡️',
  man_running_right: '🏃‍♂️‍➡️',
  ballet_dancer: '🧑‍🩰',
  dancer: '💃',
  woman_dancing: '💃',
  man_dancing: '🕺',
  levitate: '🕴️',
  levitating: '🕴️',
  person_in_suit_levitating: '🕴️',
  dancers: '👯',
  people_with_bunny_ears_partying: '👯',
  men_with_bunny_ears_partying: '👯‍♂️',
  women_with_bunny_ears_partying: '👯‍♀️',
  person_in_steamy_room: '🧖',
  man_in_steamy_room: '🧖‍♂️',
  woman_in_steamy_room: '🧖‍♀️',
  climbing: '🧗',
  person_climbing: '🧗',
  man_climbing: '🧗‍♂️',
  woman_climbing: '🧗‍♀️',
  fencer: '🤺',
  fencing: '🤺',
  person_fencing: '🤺',
  horse_racing: '🏇',
  person_skiing: '⛷️',
  skier: '⛷️',
  skiing: '⛷️',
  person_snowboarding: '🏂️',
  snowboarder: '🏂️',
  snowboarding: '🏂️',
  golfer: '🏌️',
  golfing: '🏌️',
  person_golfing: '🏌️',
  man_golfing: '🏌️‍♂️',
  woman_golfing: '🏌️‍♀️',
  person_surfing: '🏄️',
  surfer: '🏄️',
  surfing: '🏄️',
  man_surfing: '🏄‍♂️',
  woman_surfing: '🏄‍♀️',
  person_rowing_boat: '🚣',
  rowboat: '🚣',
  man_rowing_boat: '🚣‍♂️',
  woman_rowing_boat: '🚣‍♀️',
  person_swimming: '🏊️',
  swimmer: '🏊️',
  swimming: '🏊️',
  man_swimming: '🏊‍♂️',
  woman_swimming: '🏊‍♀️',
  person_bouncing_ball: '⛹️',
  man_bouncing_ball: '⛹️‍♂️',
  woman_bouncing_ball: '⛹️‍♀️',
  person_lifting_weights: '🏋️',
  weight_lifter: '🏋️',
  weight_lifting: '🏋️',
  man_lifting_weights: '🏋️‍♂️',
  woman_lifting_weights: '🏋️‍♀️',
  bicyclist: '🚴',
  biking: '🚴',
  person_biking: '🚴',
  man_biking: '🚴‍♂️',
  woman_biking: '🚴‍♀️',
  mountain_bicyclist: '🚵',
  mountain_biking: '🚵',
  person_mountain_biking: '🚵',
  man_mountain_biking: '🚵‍♂️',
  woman_mountain_biking: '🚵‍♀️',
  cartwheeling: '🤸',
  person_cartwheel: '🤸',
  man_cartwheeling: '🤸‍♂️',
  woman_cartwheeling: '🤸‍♀️',
  people_wrestling: '🤼',
  wrestlers: '🤼',
  wrestling: '🤼',
  men_wrestling: '🤼‍♂️',
  women_wrestling: '🤼‍♀️',
  person_playing_water_polo: '🤽',
  water_polo: '🤽',
  man_playing_water_polo: '🤽‍♂️',
  woman_playing_water_polo: '🤽‍♀️',
  handball: '🤾',
  person_playing_handball: '🤾',
  man_playing_handball: '🤾‍♂️',
  woman_playing_handball: '🤾‍♀️',
  juggler: '🤹',
  juggling: '🤹',
  person_juggling: '🤹',
  man_juggling: '🤹‍♂️',
  woman_juggling: '🤹‍♀️',
  person_in_lotus_position: '🧘',
  man_in_lotus_position: '🧘‍♂️',
  woman_in_lotus_position: '🧘‍♀️',
  bath: '🛀',
  person_taking_bath: '🛀',
  person_in_bed: '🛌',
  sleeping_accommodation: '🛌',
  people_holding_hands: '🧑‍🤝‍🧑',
  two_women_holding_hands: '👭',
  couple: '👫',
  two_men_holding_hands: '👬',
  couple_kiss: '💏',
  couplekiss: '💏',
  kiss_mw: '👩‍❤️‍💋‍👨',
  kiss_wm: '👩‍❤️‍💋‍👨',
  kiss_mm: '👨‍❤️‍💋‍👨',
  kiss_ww: '👩‍❤️‍💋‍👩',
  couple_with_heart: '💑',
  couple_with_heart_mw: '👩‍❤️‍👨',
  couple_with_heart_wm: '👩‍❤️‍👨',
  couple_with_heart_mm: '👨‍❤️‍👨',
  couple_with_heart_ww: '👩‍❤️‍👩',
  family_mwb: '👨‍👩‍👦',
  family_mwg: '👨‍👩‍👧',
  family_mwgb: '👨‍👩‍👧‍👦',
  family_mwbb: '👨‍👩‍👦‍👦',
  family_mwgg: '👨‍👩‍👧‍👧',
  family_mmb: '👨‍👨‍👦',
  family_mmg: '👨‍👨‍👧',
  family_mmgb: '👨‍👨‍👧‍👦',
  family_mmbb: '👨‍👨‍👦‍👦',
  family_mmgg: '👨‍👨‍👧‍👧',
  family_wwb: '👩‍👩‍👦',
  family_wwg: '👩‍👩‍👧',
  family_wwgb: '👩‍👩‍👧‍👦',
  family_wwbb: '👩‍👩‍👦‍👦',
  family_wwgg: '👩‍👩‍👧‍👧',
  family_mb: '👨‍👦',
  family_mbb: '👨‍👦‍👦',
  family_mg: '👨‍👧',
  family_mgb: '👨‍👧‍👦',
  family_mgg: '👨‍👧‍👧',
  family_wb: '👩‍👦',
  family_wbb: '👩‍👦‍👦',
  family_wg: '👩‍👧',
  family_wgb: '👩‍👧‍👦',
  family_wgg: '👩‍👧‍👧',
  speaking_head: '🗣️',
  bust_in_silhouette: '👤',
  busts_in_silhouette: '👥',
  people_hugging: '🫂',
  family: '👪️',
  family_aac: '🧑‍🧑‍🧒',
  family_aacc: '🧑‍🧑‍🧒‍🧒',
  family_aa: '🧑‍🧒',
  family_ac: '🧑‍🧒',
  family_acc: '🧑‍🧒‍🧒',
  footprints: '👣',
  fingerprint: '🫆',
  tone1: '🏻',
  tone_light: '🏻',
  tone2: '🏼',
  tone_medium_light: '🏼',
  tone3: '🏽',
  tone_medium: '🏽',
  tone4: '🏾',
  tone_medium_dark: '🏾',
  tone5: '🏿',
  tone_dark: '🏿',
  red_hair: '🦰',
  curly_hair: '🦱',
  white_hair: '🦳',
  no_hair: '🦲',
  monkey_face: '🐵',
  monkey: '🐒',
  gorilla: '🦍',
  orangutan: '🦧',
  dog_face: '🐶',
  dog: '🐕️',
  guide_dog: '🦮',
  service_dog: '🐕‍🦺',
  poodle: '🐩',
  wolf: '🐺',
  wolf_face: '🐺',
  fox: '🦊',
  fox_face: '🦊',
  raccoon: '🦝',
  cat_face: '🐱',
  cat: '🐈️',
  black_cat: '🐈‍⬛',
  lion: '🦁',
  lion_face: '🦁',
  tiger_face: '🐯',
  tiger: '🐅',
  leopard: '🐆',
  horse_face: '🐴',
  moose: '🫎',
  donkey: '🫏',
  horse: '🐎',
  racehorse: '🐎',
  unicorn: '🦄',
  unicorn_face: '🦄',
  zebra: '🦓',
  deer: '🦌',
  bison: '🦬',
  cow_face: '🐮',
  ox: '🐂',
  water_buffalo: '🐃',
  cow: '🐄',
  pig_face: '🐷',
  pig: '🐖',
  boar: '🐗',
  pig_nose: '🐽',
  ram: '🐏',
  ewe: '🐑',
  sheep: '🐑',
  goat: '🐐',
  dromedary_camel: '🐪',
  camel: '🐫',
  llama: '🦙',
  giraffe: '🦒',
  elephant: '🐘',
  mammoth: '🦣',
  rhino: '🦏',
  rhinoceros: '🦏',
  hippo: '🦛',
  mouse_face: '🐭',
  mouse: '🐁',
  rat: '🐀',
  hamster: '🐹',
  hamster_face: '🐹',
  rabbit_face: '🐰',
  rabbit: '🐇',
  chipmunk: '🐿️',
  beaver: '🦫',
  hedgehog: '🦔',
  bat: '🦇',
  bear: '🐻',
  bear_face: '🐻',
  polar_bear: '🐻‍❄️',
  polar_bear_face: '🐻‍❄️',
  koala: '🐨',
  koala_face: '🐨',
  panda: '🐼',
  panda_face: '🐼',
  sloth: '🦥',
  otter: '🦦',
  skunk: '🦨',
  kangaroo: '🦘',
  badger: '🦡',
  paw_prints: '🐾',
  turkey: '🦃',
  chicken: '🐔',
  chicken_face: '🐔',
  rooster: '🐓',
  hatching_chick: '🐣',
  baby_chick: '🐤',
  hatched_chick: '🐥',
  bird: '🐦️',
  bird_face: '🐦️',
  penguin: '🐧',
  penguin_face: '🐧',
  dove: '🕊️',
  eagle: '🦅',
  duck: '🦆',
  swan: '🦢',
  owl: '🦉',
  dodo: '🦤',
  feather: '🪶',
  flamingo: '🦩',
  peacock: '🦚',
  parrot: '🦜',
  wing: '🪽',
  black_bird: '🐦‍⬛',
  goose: '🪿',
  phoenix: '🐦‍🔥',
  frog: '🐸',
  frog_face: '🐸',
  crocodile: '🐊',
  turtle: '🐢',
  lizard: '🦎',
  snake: '🐍',
  dragon_face: '🐲',
  dragon: '🐉',
  sauropod: '🦕',
  't-rex': '🦖',
  trex: '🦖',
  spouting_whale: '🐳',
  whale: '🐋',
  dolphin: '🐬',
  orca: '🫍',
  seal: '🦭',
  fish: '🐟️',
  tropical_fish: '🐠',
  blowfish: '🐡',
  shark: '🦈',
  octopus: '🐙',
  shell: '🐚',
  coral: '🪸',
  jellyfish: '🪼',
  crab: '🦀',
  lobster: '🦞',
  shrimp: '🦐',
  squid: '🦑',
  oyster: '🦪',
  snail: '🐌',
  butterfly: '🦋',
  bug: '🐛',
  ant: '🐜',
  bee: '🐝',
  beetle: '🪲',
  lady_beetle: '🐞',
  cricket: '🦗',
  cockroach: '🪳',
  spider: '🕷️',
  spider_web: '🕸️',
  scorpion: '🦂',
  mosquito: '🦟',
  fly: '🪰',
  worm: '🪱',
  microbe: '🦠',
  bouquet: '💐',
  cherry_blossom: '🌸',
  white_flower: '💮',
  lotus: '🪷',
  rosette: '🏵️',
  rose: '🌹',
  wilted_flower: '🥀',
  hibiscus: '🌺',
  sunflower: '🌻',
  blossom: '🌼',
  tulip: '🌷',
  hyacinth: '🪻',
  seedling: '🌱',
  potted_plant: '🪴',
  evergreen_tree: '🌲',
  deciduous_tree: '🌳',
  palm_tree: '🌴',
  cactus: '🌵',
  ear_of_rice: '🌾',
  sheaf_of_rice: '🌾',
  herb: '🌿',
  shamrock: '☘️',
  four_leaf_clover: '🍀',
  maple_leaf: '🍁',
  fallen_leaf: '🍂',
  leaves: '🍃',
  empty_nest: '🪹',
  nest: '🪹',
  nest_with_eggs: '🪺',
  mushroom: '🍄',
  leafless_tree: '🪾',
  grapes: '🍇',
  melon: '🍈',
  watermelon: '🍉',
  orange: '🍊',
  tangerine: '🍊',
  lemon: '🍋',
  lime: '🍋‍🟩',
  banana: '🍌',
  pineapple: '🍍',
  mango: '🥭',
  apple: '🍎',
  red_apple: '🍎',
  green_apple: '🍏',
  pear: '🍐',
  peach: '🍑',
  cherries: '🍒',
  strawberry: '🍓',
  blueberries: '🫐',
  kiwi: '🥝',
  tomato: '🍅',
  olive: '🫒',
  coconut: '🥥',
  avocado: '🥑',
  eggplant: '🍆',
  potato: '🥔',
  carrot: '🥕',
  corn: '🌽',
  ear_of_corn: '🌽',
  hot_pepper: '🌶️',
  bell_pepper: '🫑',
  cucumber: '🥒',
  leafy_green: '🥬',
  broccoli: '🥦',
  garlic: '🧄',
  onion: '🧅',
  peanuts: '🥜',
  beans: '🫘',
  chestnut: '🌰',
  ginger: '🫚',
  pea: '🫛',
  brown_mushroom: '🍄‍🟫',
  root_vegetable: '🫜',
  bread: '🍞',
  croissant: '🥐',
  baguette_bread: '🥖',
  flatbread: '🫓',
  pretzel: '🥨',
  bagel: '🥯',
  pancakes: '🥞',
  waffle: '🧇',
  cheese: '🧀',
  meat_on_bone: '🍖',
  poultry_leg: '🍗',
  cut_of_meat: '🥩',
  bacon: '🥓',
  hamburger: '🍔',
  french_fries: '🍟',
  fries: '🍟',
  pizza: '🍕',
  hotdog: '🌭',
  sandwich: '🥪',
  taco: '🌮',
  burrito: '🌯',
  tamale: '🫔',
  stuffed_flatbread: '🥙',
  falafel: '🧆',
  egg: '🥚',
  cooking: '🍳',
  fried_egg: '🍳',
  shallow_pan_of_food: '🥘',
  pot_of_food: '🍲',
  stew: '🍲',
  fondue: '🫕',
  bowl_with_spoon: '🥣',
  green_salad: '🥗',
  salad: '🥗',
  popcorn: '🍿',
  butter: '🧈',
  salt: '🧂',
  canned_food: '🥫',
  bento: '🍱',
  bento_box: '🍱',
  rice_cracker: '🍘',
  rice_ball: '🍙',
  cooked_rice: '🍚',
  rice: '🍚',
  curry: '🍛',
  curry_rice: '🍛',
  ramen: '🍜',
  steaming_bowl: '🍜',
  spaghetti: '🍝',
  sweet_potato: '🍠',
  oden: '🍢',
  sushi: '🍣',
  fried_shrimp: '🍤',
  fish_cake: '🍥',
  moon_cake: '🥮',
  dango: '🍡',
  dumpling: '🥟',
  fortune_cookie: '🥠',
  takeout_box: '🥡',
  icecream: '🍦',
  soft_serve: '🍦',
  shaved_ice: '🍧',
  ice_cream: '🍨',
  doughnut: '🍩',
  cookie: '🍪',
  birthday: '🎂',
  birthday_cake: '🎂',
  cake: '🍰',
  shortcake: '🍰',
  cupcake: '🧁',
  pie: '🥧',
  chocolate_bar: '🍫',
  candy: '🍬',
  lollipop: '🍭',
  custard: '🍮',
  honey_pot: '🍯',
  baby_bottle: '🍼',
  glass_of_milk: '🥛',
  milk: '🥛',
  coffee: '☕️',
  teapot: '🫖',
  tea: '🍵',
  sake: '🍶',
  champagne: '🍾',
  wine_glass: '🍷',
  cocktail: '🍸️',
  tropical_drink: '🍹',
  beer: '🍺',
  beers: '🍻',
  clinking_glasses: '🥂',
  tumbler_glass: '🥃',
  whisky: '🥃',
  pour: '🫗',
  pouring_liquid: '🫗',
  cup_with_straw: '🥤',
  boba_drink: '🧋',
  bubble_tea: '🧋',
  beverage_box: '🧃',
  juice_box: '🧃',
  mate: '🧉',
  ice: '🧊',
  ice_cube: '🧊',
  chopsticks: '🥢',
  fork_knife_plate: '🍽️',
  fork_and_knife: '🍴',
  spoon: '🥄',
  knife: '🔪',
  jar: '🫙',
  amphora: '🏺',
  earth_africa: '🌍️',
  earth_europe: '🌍️',
  earth_americas: '🌎️',
  earth_asia: '🌏️',
  globe_with_meridians: '🌐',
  world_map: '🗺️',
  japan_map: '🗾',
  compass: '🧭',
  mountain_snow: '🏔️',
  mountain: '⛰️',
  landslide: '🛘',
  volcano: '🌋',
  mount_fuji: '🗻',
  camping: '🏕️',
  beach: '🏖️',
  beach_with_umbrella: '🏖️',
  desert: '🏜️',
  desert_island: '🏝️',
  island: '🏝️',
  national_park: '🏞️',
  stadium: '🏟️',
  classical_building: '🏛️',
  building_construction: '🏗️',
  construction_site: '🏗️',
  bricks: '🧱',
  rock: '🪨',
  wood: '🪵',
  hut: '🛖',
  homes: '🏘️',
  houses: '🏘️',
  derelict_house: '🏚️',
  house_abandoned: '🏚️',
  house: '🏠️',
  house_with_garden: '🏡',
  office: '🏢',
  post_office: '🏣',
  european_post_office: '🏤',
  hospital: '🏥',
  bank: '🏦',
  hotel: '🏨',
  love_hotel: '🏩',
  convenience_store: '🏪',
  school: '🏫',
  department_store: '🏬',
  factory: '🏭️',
  japanese_castle: '🏯',
  castle: '🏰',
  european_castle: '🏰',
  wedding: '💒',
  tokyo_tower: '🗼',
  statue_of_liberty: '🗽',
  church: '⛪️',
  mosque: '🕌',
  hindu_temple: '🛕',
  synagogue: '🕍',
  shinto_shrine: '⛩️',
  kaaba: '🕋',
  fountain: '⛲️',
  tent: '⛺️',
  foggy: '🌁',
  night_with_stars: '🌃',
  cityscape: '🏙️',
  sunrise_over_mountains: '🌄',
  sunrise: '🌅',
  city_dusk: '🌆',
  city_sunrise: '🌇',
  city_sunset: '🌇',
  bridge_at_night: '🌉',
  hotsprings: '♨️',
  carousel_horse: '🎠',
  playground_slide: '🛝',
  slide: '🛝',
  ferris_wheel: '🎡',
  roller_coaster: '🎢',
  barber: '💈',
  barber_pole: '💈',
  circus_tent: '🎪',
  steam_locomotive: '🚂',
  railway_car: '🚃',
  bullettrain_side: '🚄',
  bullettrain_front: '🚅',
  train: '🚆',
  metro: '🚇️',
  light_rail: '🚈',
  station: '🚉',
  tram: '🚊',
  monorail: '🚝',
  mountain_railway: '🚞',
  tram_car: '🚋',
  bus: '🚌',
  oncoming_bus: '🚍️',
  trolleybus: '🚎',
  minibus: '🚐',
  ambulance: '🚑️',
  fire_engine: '🚒',
  police_car: '🚓',
  oncoming_police_car: '🚔️',
  taxi: '🚕',
  oncoming_taxi: '🚖',
  car: '🚗',
  red_car: '🚗',
  oncoming_automobile: '🚘️',
  blue_car: '🚙',
  suv: '🚙',
  pickup_truck: '🛻',
  delivery_truck: '🚚',
  truck: '🚚',
  articulated_lorry: '🚛',
  tractor: '🚜',
  racing_car: '🏎️',
  motorcycle: '🏍️',
  motor_scooter: '🛵',
  manual_wheelchair: '🦽',
  motorized_wheelchair: '🦼',
  auto_rickshaw: '🛺',
  bicycle: '🚲️',
  bike: '🚲️',
  scooter: '🛴',
  skateboard: '🛹',
  roller_skate: '🛼',
  busstop: '🚏',
  motorway: '🛣️',
  railway_track: '🛤️',
  oil_drum: '🛢️',
  fuelpump: '⛽️',
  wheel: '🛞',
  rotating_light: '🚨',
  traffic_light: '🚥',
  vertical_traffic_light: '🚦',
  octagonal_sign: '🛑',
  stop_sign: '🛑',
  construction: '🚧',
  anchor: '⚓️',
  lifebuoy: '🛟',
  ring_buoy: '🛟',
  sailboat: '⛵️',
  canoe: '🛶',
  speedboat: '🚤',
  cruise_ship: '🛳️',
  passenger_ship: '🛳️',
  ferry: '⛴️',
  motorboat: '🛥️',
  ship: '🚢',
  airplane: '✈️',
  small_airplane: '🛩️',
  airplane_departure: '🛫',
  airplane_arriving: '🛬',
  parachute: '🪂',
  seat: '💺',
  helicopter: '🚁',
  suspension_railway: '🚟',
  mountain_cableway: '🚠',
  aerial_tramway: '🚡',
  satellite: '🛰️',
  rocket: '🚀',
  flying_saucer: '🛸',
  bellhop: '🛎️',
  luggage: '🧳',
  hourglass: '⌛️',
  hourglass_flowing_sand: '⏳️',
  watch: '⌚️',
  alarm_clock: '⏰️',
  stopwatch: '⏱️',
  timer_clock: '⏲️',
  clock: '🕰️',
  clock12: '🕛️',
  clock1230: '🕧️',
  clock1: '🕐️',
  clock130: '🕜️',
  clock2: '🕑️',
  clock230: '🕝️',
  clock3: '🕒️',
  clock330: '🕞️',
  clock4: '🕓️',
  clock430: '🕟️',
  clock5: '🕔️',
  clock530: '🕠️',
  clock6: '🕕️',
  clock630: '🕡️',
  clock7: '🕖️',
  clock730: '🕢️',
  clock8: '🕗️',
  clock830: '🕣️',
  clock9: '🕘️',
  clock930: '🕤️',
  clock10: '🕙️',
  clock1030: '🕥️',
  clock11: '🕚️',
  clock1130: '🕦️',
  new_moon: '🌑',
  waxing_crescent_moon: '🌒',
  first_quarter_moon: '🌓',
  waxing_gibbous_moon: '🌔',
  full_moon: '🌕️',
  waning_gibbous_moon: '🌖',
  last_quarter_moon: '🌗',
  waning_crescent_moon: '🌘',
  crescent_moon: '🌙',
  new_moon_with_face: '🌚',
  first_quarter_moon_with_face: '🌛',
  last_quarter_moon_with_face: '🌜️',
  thermometer: '🌡️',
  sun: '☀️',
  full_moon_with_face: '🌝',
  sun_with_face: '🌞',
  ringed_planet: '🪐',
  saturn: '🪐',
  star: '⭐️',
  glowing_star: '🌟',
  star2: '🌟',
  shooting_star: '🌠',
  stars: '🌠',
  milky_way: '🌌',
  cloud: '☁️',
  partly_sunny: '⛅️',
  sun_behind_cloud: '⛅️',
  stormy: '⛈️',
  thunder_cloud_and_rain: '⛈️',
  sun_behind_small_cloud: '🌤️',
  sunny: '🌤️',
  cloudy: '🌥️',
  sun_behind_large_cloud: '🌥️',
  sun_and_rain: '🌦️',
  sun_behind_rain_cloud: '🌦️',
  cloud_with_rain: '🌧️',
  rainy: '🌧️',
  cloud_with_snow: '🌨️',
  snowy: '🌨️',
  cloud_with_lightning: '🌩️',
  lightning: '🌩️',
  tornado: '🌪️',
  fog: '🌫️',
  wind_blowing_face: '🌬️',
  cyclone: '🌀',
  rainbow: '🌈',
  closed_umbrella: '🌂',
  umbrella: '☂️',
  umbrella_with_rain: '☔️',
  beach_umbrella: '⛱️',
  umbrella_on_ground: '⛱️',
  high_voltage: '⚡️',
  zap: '⚡️',
  snowflake: '❄️',
  snowman2: '☃️',
  snowman: '⛄️',
  comet: '☄️',
  fire: '🔥',
  droplet: '💧',
  ocean: '🌊',
  water_wave: '🌊',
  jack_o_lantern: '🎃',
  christmas_tree: '🎄',
  fireworks: '🎆',
  sparkler: '🎇',
  firecracker: '🧨',
  sparkles: '✨️',
  balloon: '🎈',
  party: '🎉',
  party_popper: '🎉',
  tada: '🎉',
  confetti_ball: '🎊',
  tanabata_tree: '🎋',
  bamboo: '🎍',
  dolls: '🎎',
  carp_streamer: '🎏',
  flags: '🎏',
  wind_chime: '🎐',
  moon_ceremony: '🎑',
  rice_scene: '🎑',
  red_envelope: '🧧',
  ribbon: '🎀',
  gift: '🎁',
  reminder_ribbon: '🎗️',
  admission_tickets: '🎟️',
  tickets: '🎟️',
  ticket: '🎫',
  military_medal: '🎖️',
  trophy: '🏆️',
  sports_medal: '🏅',
  '1st': '🥇',
  first_place_medal: '🥇',
  '2nd': '🥈',
  second_place_medal: '🥈',
  '3rd': '🥉',
  third_place_medal: '🥉',
  soccer: '⚽️',
  baseball: '⚾️',
  softball: '🥎',
  basketball: '🏀',
  volleyball: '🏐',
  football: '🏈',
  rugby_football: '🏉',
  tennis: '🎾',
  flying_disc: '🥏',
  bowling: '🎳',
  cricket_game: '🏏',
  field_hockey: '🏑',
  hockey: '🏒',
  lacrosse: '🥍',
  ping_pong: '🏓',
  badminton: '🏸',
  boxing_glove: '🥊',
  martial_arts_uniform: '🥋',
  goal_net: '🥅',
  golf: '⛳️',
  ice_skate: '⛸️',
  fishing_pole: '🎣',
  fishing_pole_and_fish: '🎣',
  diving_mask: '🤿',
  running_shirt: '🎽',
  running_shirt_with_sash: '🎽',
  ski: '🎿',
  sled: '🛷',
  curling_stone: '🥌',
  bullseye: '🎯',
  dart: '🎯',
  direct_hit: '🎯',
  yo_yo: '🪀',
  kite: '🪁',
  gun: '🔫',
  pistol: '🔫',
  '8ball': '🎱',
  billiards: '🎱',
  crystal_ball: '🔮',
  magic_wand: '🪄',
  controller: '🎮️',
  video_game: '🎮️',
  joystick: '🕹️',
  slot_machine: '🎰',
  game_die: '🎲',
  jigsaw: '🧩',
  puzzle_piece: '🧩',
  teddy_bear: '🧸',
  pinata: '🪅',
  disco: '🪩',
  disco_ball: '🪩',
  mirror_ball: '🪩',
  nesting_dolls: '🪆',
  spades: '♠️',
  hearts: '♥️',
  diamonds: '♦️',
  clubs: '♣️',
  chess_pawn: '♟️',
  black_joker: '🃏',
  mahjong: '🀄️',
  flower_playing_cards: '🎴',
  performing_arts: '🎭️',
  frame_with_picture: '🖼️',
  framed_picture: '🖼️',
  art: '🎨',
  palette: '🎨',
  thread: '🧵',
  sewing_needle: '🪡',
  yarn: '🧶',
  knot: '🪢',
  eyeglasses: '👓️',
  glasses: '👓️',
  sunglasses: '🕶️',
  goggles: '🥽',
  lab_coat: '🥼',
  safety_vest: '🦺',
  necktie: '👔',
  shirt: '👕',
  jeans: '👖',
  scarf: '🧣',
  gloves: '🧤',
  coat: '🧥',
  socks: '🧦',
  dress: '👗',
  kimono: '👘',
  sari: '🥻',
  one_piece_swimsuit: '🩱',
  briefs: '🩲',
  shorts: '🩳',
  bikini: '👙',
  womans_clothes: '👚',
  folding_fan: '🪭',
  purse: '👛',
  handbag: '👜',
  clutch_bag: '👝',
  pouch: '👝',
  shopping_bags: '🛍️',
  backpack: '🎒',
  school_satchel: '🎒',
  thong_sandal: '🩴',
  mans_shoe: '👞',
  athletic_shoe: '👟',
  sneaker: '👟',
  hiking_boot: '🥾',
  flat_shoe: '🥿',
  womans_flat_shoe: '🥿',
  high_heel: '👠',
  sandal: '👡',
  ballet_shoes: '🩰',
  boot: '👢',
  hair_pick: '🪮',
  crown: '👑',
  womans_hat: '👒',
  top_hat: '🎩',
  tophat: '🎩',
  graduation_cap: '🎓️',
  mortar_board: '🎓️',
  billed_cap: '🧢',
  military_helmet: '🪖',
  helmet_with_cross: '⛑️',
  rescue_worker_helmet: '⛑️',
  prayer_beads: '📿',
  lipstick: '💄',
  ring: '💍',
  gem: '💎',
  mute: '🔇',
  no_sound: '🔇',
  low_volume: '🔈️',
  quiet_sound: '🔈️',
  speaker: '🔈️',
  medium_volumne: '🔉',
  sound: '🔉',
  high_volume: '🔊',
  loud_sound: '🔊',
  loudspeaker: '📢',
  mega: '📣',
  megaphone: '📣',
  postal_horn: '📯',
  bell: '🔔',
  no_bell: '🔕',
  musical_score: '🎼',
  musical_note: '🎵',
  musical_notes: '🎶',
  notes: '🎶',
  studio_microphone: '🎙️',
  level_slider: '🎚️',
  control_knobs: '🎛️',
  microphone: '🎤',
  headphones: '🎧️',
  radio: '📻️',
  saxophone: '🎷',
  trumpet: '🎺',
  trombone: '🪊',
  accordion: '🪗',
  guitar: '🎸',
  musical_keyboard: '🎹',
  violin: '🎻',
  banjo: '🪕',
  drum: '🥁',
  long_drum: '🪘',
  maracas: '🪇',
  flute: '🪈',
  harp: '🪉',
  android: '📱',
  iphone: '📱',
  mobile_phone: '📱',
  calling: '📲',
  mobile_phone_arrow: '📲',
  telephone: '☎️',
  telephone_receiver: '📞',
  pager: '📟️',
  fax: '📠',
  fax_machine: '📠',
  battery: '🔋',
  low_battery: '🪫',
  electric_plug: '🔌',
  laptop: '💻️',
  computer: '🖥️',
  desktop_computer: '🖥️',
  printer: '🖨️',
  keyboard: '⌨️',
  computer_mouse: '🖱️',
  trackball: '🖲️',
  computer_disk: '💽',
  minidisc: '💽',
  floppy_disk: '💾',
  cd: '💿️',
  optical_disk: '💿️',
  dvd: '📀',
  abacus: '🧮',
  movie_camera: '🎥',
  film_frames: '🎞️',
  film_projector: '📽️',
  clapper: '🎬️',
  tv: '📺️',
  camera: '📷️',
  camera_with_flash: '📸',
  video_camera: '📹️',
  vhs: '📼',
  videocassette: '📼',
  mag: '🔍️',
  mag_right: '🔎',
  candle: '🕯️',
  bulb: '💡',
  light_bulb: '💡',
  flashlight: '🔦',
  izakaya_lantern: '🏮',
  red_paper_lantern: '🏮',
  diya_lamp: '🪔',
  notebook_with_decorative_cover: '📔',
  closed_book: '📕',
  book: '📖',
  open_book: '📖',
  green_book: '📗',
  blue_book: '📘',
  orange_book: '📙',
  books: '📚️',
  notebook: '📓',
  ledger: '📒',
  page_with_curl: '📃',
  scroll: '📜',
  page_facing_up: '📄',
  newspaper: '📰',
  rolled_up_newspaper: '🗞️',
  bookmark_tabs: '📑',
  bookmark: '🔖',
  label: '🏷️',
  coin: '🪙',
  moneybag: '💰️',
  treasure_chest: '🪎',
  yen: '💴',
  dollar: '💵',
  euro: '💶',
  pound: '💷',
  money_with_wings: '💸',
  credit_card: '💳️',
  receipt: '🧾',
  chart: '💹',
  envelope: '✉️',
  'e-mail': '📧',
  email: '📧',
  incoming_envelope: '📨',
  envelope_with_arrow: '📩',
  outbox_tray: '📤️',
  inbox_tray: '📥️',
  package: '📦️',
  mailbox: '📫️',
  mailbox_closed: '📪️',
  mailbox_with_mail: '📬️',
  mailbox_with_no_mail: '📭️',
  postbox: '📮',
  ballot_box: '🗳️',
  pencil: '✏️',
  black_nib: '✒️',
  fountain_pen: '🖋️',
  pen: '🖊️',
  paintbrush: '🖌️',
  crayon: '🖍️',
  memo: '📝',
  briefcase: '💼',
  file_folder: '📁',
  open_file_folder: '📂',
  card_index_dividers: '🗂️',
  date: '📅',
  calendar: '📆',
  notepad_spiral: '🗒️',
  calendar_spiral: '🗓️',
  card_index: '📇',
  chart_increasing: '📈',
  chart_with_upwards_trend: '📈',
  chart_decreasing: '📉',
  chart_with_downwards_trend: '📉',
  bar_chart: '📊',
  clipboard: '📋️',
  pushpin: '📌',
  round_pushpin: '📍',
  paperclip: '📎',
  paperclips: '🖇️',
  straight_ruler: '📏',
  triangular_ruler: '📐',
  scissors: '✂️',
  card_file_box: '🗃️',
  file_cabinet: '🗄️',
  trashcan: '🗑️',
  wastebasket: '🗑️',
  lock: '🔒️',
  locked: '🔒️',
  unlock: '🔓️',
  unlocked: '🔓️',
  lock_with_ink_pen: '🔏',
  locked_with_pen: '🔏',
  closed_lock_with_key: '🔐',
  locked_with_key: '🔐',
  key: '🔑',
  old_key: '🗝️',
  hammer: '🔨',
  axe: '🪓',
  pick: '⛏️',
  hammer_and_pick: '⚒️',
  hammer_and_wrench: '🛠️',
  dagger: '🗡️',
  crossed_swords: '⚔️',
  bomb: '💣️',
  boomerang: '🪃',
  bow_and_arrow: '🏹',
  shield: '🛡️',
  carpentry_saw: '🪚',
  wrench: '🔧',
  screwdriver: '🪛',
  nut_and_bolt: '🔩',
  gear: '⚙️',
  clamp: '🗜️',
  compression: '🗜️',
  scales: '⚖️',
  probing_cane: '🦯',
  white_cane: '🦯',
  link: '🔗',
  broken_chain: '⛓️‍💥',
  chains: '⛓️',
  hook: '🪝',
  toolbox: '🧰',
  magnet: '🧲',
  ladder: '🪜',
  shovel: '🪏',
  alembic: '⚗️',
  test_tube: '🧪',
  petri_dish: '🧫',
  dna: '🧬',
  double_helix: '🧬',
  microscope: '🔬',
  telescope: '🔭',
  satellite_antenna: '📡',
  syringe: '💉',
  drop_of_blood: '🩸',
  pill: '💊',
  adhesive_bandage: '🩹',
  bandaid: '🩹',
  crutch: '🩼',
  stethoscope: '🩺',
  'x-ray': '🩻',
  xray: '🩻',
  door: '🚪',
  elevator: '🛗',
  mirror: '🪞',
  window: '🪟',
  bed: '🛏️',
  couch_and_lamp: '🛋️',
  chair: '🪑',
  toilet: '🚽',
  plunger: '🪠',
  shower: '🚿',
  bathtub: '🛁',
  mouse_trap: '🪤',
  razor: '🪒',
  lotion_bottle: '🧴',
  safety_pin: '🧷',
  broom: '🧹',
  basket: '🧺',
  roll_of_paper: '🧻',
  toilet_paper: '🧻',
  bucket: '🪣',
  soap: '🧼',
  bubbles: '🫧',
  toothbrush: '🪥',
  sponge: '🧽',
  fire_extinguisher: '🧯',
  shopping_cart: '🛒',
  cigarette: '🚬',
  smoking: '🚬',
  coffin: '⚰️',
  headstone: '🪦',
  funeral_urn: '⚱️',
  nazar_amulet: '🧿',
  hamsa: '🪬',
  moai: '🗿',
  moyai: '🗿',
  placard: '🪧',
  id_card: '🪪',
  atm: '🏧',
  litter_bin: '🚮',
  put_litter_in_its_place: '🚮',
  potable_water: '🚰',
  handicapped: '♿️',
  wheelchair: '♿️',
  mens: '🚹️',
  womens: '🚺️',
  bathroom: '🚻',
  restroom: '🚻',
  baby_symbol: '🚼️',
  water_closet: '🚾',
  wc: '🚾',
  passport_control: '🛂',
  customs: '🛃',
  baggage_claim: '🛄',
  left_luggage: '🛅',
  warning: '⚠️',
  children_crossing: '🚸',
  no_entry: '⛔️',
  no_entry_sign: '🚫',
  no_bicycles: '🚳',
  no_smoking: '🚭️',
  do_not_litter: '🚯',
  no_littering: '🚯',
  'non-potable_water': '🚱',
  no_pedestrians: '🚷',
  no_mobile_phones: '📵',
  no_one_under_18: '🔞',
  underage: '🔞',
  radioactive: '☢️',
  biohazard: '☣️',
  arrow_up: '⬆️',
  arrow_upper_right: '↗️',
  arrow_right: '➡️',
  arrow_lower_right: '↘️',
  arrow_down: '⬇️',
  arrow_lower_left: '↙️',
  arrow_left: '⬅️',
  arrow_upper_left: '↖️',
  arrow_up_down: '↕️',
  left_right_arrow: '↔️',
  arrow_left_hook: '↩️',
  leftwards_arrow_with_hook: '↩️',
  arrow_right_hook: '↪️',
  rightwards_arrow_with_hook: '↪️',
  arrow_heading_up: '⤴️',
  arrow_heading_down: '⤵️',
  arrows_clockwise: '🔃',
  clockwise: '🔃',
  arrows_counterclockwise: '🔄',
  counterclockwise: '🔄',
  back: '🔙',
  end: '🔚',
  on: '🔛',
  soon: '🔜',
  top: '🔝',
  place_of_worship: '🛐',
  atom: '⚛️',
  atom_symbol: '⚛️',
  om: '🕉️',
  star_of_david: '✡️',
  wheel_of_dharma: '☸️',
  yin_yang: '☯️',
  latin_cross: '✝️',
  orthodox_cross: '☦️',
  star_and_crescent: '☪️',
  peace: '☮️',
  peace_symbol: '☮️',
  menorah: '🕎',
  six_pointed_star: '🔯',
  khanda: '🪯',
  aries: '♈️',
  taurus: '♉️',
  gemini: '♊️',
  cancer: '♋️',
  leo: '♌️',
  virgo: '♍️',
  libra: '♎️',
  scorpius: '♏️',
  sagittarius: '♐️',
  capricorn: '♑️',
  aquarius: '♒️',
  pisces: '♓️',
  ophiuchus: '⛎️',
  shuffle: '🔀',
  twisted_rightwards_arrows: '🔀',
  repeat: '🔁',
  repeat_one: '🔂',
  arrow_forward: '▶️',
  play: '▶️',
  fast_forward: '⏩️',
  next_track: '⏭️',
  play_pause: '⏯️',
  arrow_backward: '◀️',
  reverse: '◀️',
  fast_reverse: '⏪️',
  rewind: '⏪️',
  previous_track: '⏮️',
  arrow_up_small: '🔼',
  up: '🔼',
  arrow_double_up: '⏫️',
  fast_up: '⏫️',
  arrow_down_small: '🔽',
  down: '🔽',
  arrow_double_down: '⏬️',
  fast_down: '⏬️',
  pause: '⏸️',
  stop: '⏹️',
  record: '⏺️',
  eject: '⏏️',
  cinema: '🎦',
  dim_button: '🔅',
  low_brightness: '🔅',
  bright_button: '🔆',
  high_brightness: '🔆',
  antenna_bars: '📶',
  signal_strength: '📶',
  wireless: '🛜',
  vibration_mode: '📳',
  mobile_phone_off: '📴',
  female: '♀️',
  female_sign: '♀️',
  male: '♂️',
  male_sign: '♂️',
  transgender_symbol: '⚧️',
  multiplication: '✖️',
  multiply: '✖️',
  plus: '➕️',
  minus: '➖️',
  divide: '➗️',
  division: '➗️',
  heavy_equals_sign: '🟰',
  infinity: '♾️',
  bangbang: '‼️',
  double_exclamation: '‼️',
  exclamation_question: '⁉️',
  interrobang: '⁉️',
  question: '❓️',
  white_question: '❔️',
  white_exclamation: '❕️',
  exclamation: '❗️',
  wavy_dash: '〰️',
  currency_exchange: '💱',
  heavy_dollar_sign: '💲',
  medical: '⚕️',
  medical_symbol: '⚕️',
  recycle: '♻️',
  recycling_symbol: '♻️',
  'fleur-de-lis': '⚜️',
  trident: '🔱',
  name_badge: '📛',
  beginner: '🔰',
  hollow_red_circle: '⭕️',
  red_o: '⭕️',
  check_mark_button: '✅️',
  white_check_mark: '✅️',
  ballot_box_with_check: '☑️',
  check_mark: '✔️',
  heavy_check_mark: '✔️',
  cross_mark: '❌️',
  x: '❌️',
  cross_mark_button: '❎️',
  negative_squared_cross_mark: '❎️',
  curly_loop: '➰️',
  double_curly_loop: '➿️',
  loop: '➿️',
  part_alternation_mark: '〽️',
  eight_spoked_asterisk: '✳️',
  eight_pointed_black_star: '✴️',
  sparkle: '❇️',
  copyright: '©️',
  registered: '®️',
  tm: '™️',
  trade_mark: '™️',
  splatter: '🫟',
  hash: '#️⃣',
  number_sign: '#️⃣',
  asterisk: '*️⃣',
  zero: '0️⃣',
  one: '1️⃣',
  two: '2️⃣',
  three: '3️⃣',
  four: '4️⃣',
  five: '5️⃣',
  six: '6️⃣',
  seven: '7️⃣',
  eight: '8️⃣',
  nine: '9️⃣',
  ten: '🔟',
  capital_abcd: '🔠',
  abcd: '🔡',
  symbols: '🔣',
  abc: '🔤',
  a: '🅰️',
  a_blood: '🅰️',
  ab: '🆎',
  ab_blood: '🆎',
  b: '🅱️',
  b_blood: '🅱️',
  cl: '🆑',
  cool: '🆒',
  free: '🆓',
  info: 'ℹ️',
  information_source: 'ℹ️',
  id: '🆔',
  m: 'Ⓜ️',
  new: '🆕',
  ng: '🆖',
  o: '🅾️',
  o_blood: '🅾️',
  ok: '🆗',
  parking: '🅿️',
  sos: '🆘',
  up2: '🆙',
  vs: '🆚',
  ja_here: '🈁',
  koko: '🈁',
  ja_service_charge: '🈂️',
  ja_monthly_amount: '🈷️',
  ja_not_free_of_carge: '🈶',
  ja_reserved: '🈯️',
  ideograph_advantage: '🉐',
  ja_bargain: '🉐',
  ja_discount: '🈹',
  ja_free_of_charge: '🈚️',
  ja_prohibited: '🈲',
  accept: '🉑',
  ja_acceptable: '🉑',
  ja_application: '🈸',
  ja_passing_grade: '🈴',
  ja_vacancy: '🈳',
  congratulations: '㊗️',
  ja_congratulations: '㊗️',
  ja_secret: '㊙️',
  secret: '㊙️',
  ja_open_for_business: '🈺',
  ja_no_vacancy: '🈵',
  red_circle: '🔴',
  orange_circle: '🟠',
  yellow_circle: '🟡',
  green_circle: '🟢',
  blue_circle: '🔵',
  purple_circle: '🟣',
  brown_circle: '🟤',
  black_circle: '⚫️',
  white_circle: '⚪️',
  red_square: '🟥',
  orange_square: '🟧',
  yellow_square: '🟨',
  green_square: '🟩',
  blue_square: '🟦',
  purple_square: '🟪',
  brown_square: '🟫',
  black_large_square: '⬛️',
  white_large_square: '⬜️',
  black_medium_square: '◼️',
  white_medium_square: '◻️',
  black_medium_small_square: '◾️',
  white_medium_small_square: '◽️',
  black_small_square: '▪️',
  white_small_square: '▫️',
  large_orange_diamond: '🔶',
  large_blue_diamond: '🔷',
  small_orange_diamond: '🔸',
  small_blue_diamond: '🔹',
  small_red_triangle: '🔺',
  small_red_triangle_down: '🔻',
  diamond_shape_with_a_dot_inside: '💠',
  diamond_with_a_dot: '💠',
  radio_button: '🔘',
  white_square_button: '🔳',
  black_square_button: '🔲',
  checkered_flag: '🏁',
  triangular_flag: '🚩',
  triangular_flag_on_post: '🚩',
  crossed_flags: '🎌',
  black_flag: '🏴',
  white_flag: '🏳️',
  rainbow_flag: '🏳️‍🌈',
  transgender_flag: '🏳️‍⚧️',
  jolly_roger: '🏴‍☠️',
  pirate_flag: '🏴‍☠️',
  ascension_island: '🇦🇨',
  flag_ac: '🇦🇨',
  andorra: '🇦🇩',
  flag_ad: '🇦🇩',
  flag_ae: '🇦🇪',
  united_arab_emirates: '🇦🇪',
  afghanistan: '🇦🇫',
  flag_af: '🇦🇫',
  antigua_barbuda: '🇦🇬',
  flag_ag: '🇦🇬',
  anguilla: '🇦🇮',
  flag_ai: '🇦🇮',
  albania: '🇦🇱',
  flag_al: '🇦🇱',
  armenia: '🇦🇲',
  flag_am: '🇦🇲',
  angola: '🇦🇴',
  flag_ao: '🇦🇴',
  antarctica: '🇦🇶',
  flag_aq: '🇦🇶',
  argentina: '🇦🇷',
  flag_ar: '🇦🇷',
  american_samoa: '🇦🇸',
  flag_as: '🇦🇸',
  austria: '🇦🇹',
  flag_at: '🇦🇹',
  australia: '🇦🇺',
  flag_au: '🇦🇺',
  aruba: '🇦🇼',
  flag_aw: '🇦🇼',
  aland_islands: '🇦🇽',
  flag_ax: '🇦🇽',
  azerbaijan: '🇦🇿',
  flag_az: '🇦🇿',
  bosnia_herzegovina: '🇧🇦',
  flag_ba: '🇧🇦',
  barbados: '🇧🇧',
  flag_bb: '🇧🇧',
  bangladesh: '🇧🇩',
  flag_bd: '🇧🇩',
  belgium: '🇧🇪',
  flag_be: '🇧🇪',
  burkina_faso: '🇧🇫',
  flag_bf: '🇧🇫',
  bulgaria: '🇧🇬',
  flag_bg: '🇧🇬',
  bahrain: '🇧🇭',
  flag_bh: '🇧🇭',
  burundi: '🇧🇮',
  flag_bi: '🇧🇮',
  benin: '🇧🇯',
  flag_bj: '🇧🇯',
  flag_bl: '🇧🇱',
  st_barthelemy: '🇧🇱',
  bermuda: '🇧🇲',
  flag_bm: '🇧🇲',
  brunei: '🇧🇳',
  flag_bn: '🇧🇳',
  bolivia: '🇧🇴',
  flag_bo: '🇧🇴',
  caribbean_netherlands: '🇧🇶',
  flag_bq: '🇧🇶',
  brazil: '🇧🇷',
  flag_br: '🇧🇷',
  bahamas: '🇧🇸',
  flag_bs: '🇧🇸',
  bhutan: '🇧🇹',
  flag_bt: '🇧🇹',
  bouvet_island: '🇧🇻',
  flag_bv: '🇧🇻',
  botswana: '🇧🇼',
  flag_bw: '🇧🇼',
  belarus: '🇧🇾',
  flag_by: '🇧🇾',
  belize: '🇧🇿',
  flag_bz: '🇧🇿',
  canada: '🇨🇦',
  flag_ca: '🇨🇦',
  cocos_islands: '🇨🇨',
  flag_cc: '🇨🇨',
  congo_kinshasa: '🇨🇩',
  flag_cd: '🇨🇩',
  central_african_republic: '🇨🇫',
  flag_cf: '🇨🇫',
  congo_brazzaville: '🇨🇬',
  flag_cg: '🇨🇬',
  flag_ch: '🇨🇭',
  switzerland: '🇨🇭',
  cote_divoire: '🇨🇮',
  flag_ci: '🇨🇮',
  cook_islands: '🇨🇰',
  flag_ck: '🇨🇰',
  chile: '🇨🇱',
  flag_cl: '🇨🇱',
  cameroon: '🇨🇲',
  flag_cm: '🇨🇲',
  china: '🇨🇳',
  flag_cn: '🇨🇳',
  colombia: '🇨🇴',
  flag_co: '🇨🇴',
  clipperton_island: '🇨🇵',
  flag_cp: '🇨🇵',
  flag_cq: '🇨🇶',
  sark: '🇨🇶',
  costa_rica: '🇨🇷',
  flag_cr: '🇨🇷',
  cuba: '🇨🇺',
  flag_cu: '🇨🇺',
  cape_verde: '🇨🇻',
  flag_cv: '🇨🇻',
  curacao: '🇨🇼',
  flag_cw: '🇨🇼',
  christmas_island: '🇨🇽',
  flag_cx: '🇨🇽',
  cyprus: '🇨🇾',
  flag_cy: '🇨🇾',
  czech_republic: '🇨🇿',
  czechia: '🇨🇿',
  flag_cz: '🇨🇿',
  flag_de: '🇩🇪',
  germany: '🇩🇪',
  diego_garcia: '🇩🇬',
  flag_dg: '🇩🇬',
  djibouti: '🇩🇯',
  flag_dj: '🇩🇯',
  denmark: '🇩🇰',
  flag_dk: '🇩🇰',
  dominica: '🇩🇲',
  flag_dm: '🇩🇲',
  dominican_republic: '🇩🇴',
  flag_do: '🇩🇴',
  algeria: '🇩🇿',
  flag_dz: '🇩🇿',
  ceuta_melilla: '🇪🇦',
  flag_ea: '🇪🇦',
  ecuador: '🇪🇨',
  flag_ec: '🇪🇨',
  estonia: '🇪🇪',
  flag_ee: '🇪🇪',
  egypt: '🇪🇬',
  flag_eg: '🇪🇬',
  flag_eh: '🇪🇭',
  western_sahara: '🇪🇭',
  eritrea: '🇪🇷',
  flag_er: '🇪🇷',
  flag_es: '🇪🇸',
  spain: '🇪🇸',
  ethiopia: '🇪🇹',
  flag_et: '🇪🇹',
  european_union: '🇪🇺',
  flag_eu: '🇪🇺',
  finland: '🇫🇮',
  flag_fi: '🇫🇮',
  fiji: '🇫🇯',
  flag_fj: '🇫🇯',
  falkland_islands: '🇫🇰',
  flag_fk: '🇫🇰',
  flag_fm: '🇫🇲',
  micronesia: '🇫🇲',
  faroe_islands: '🇫🇴',
  flag_fo: '🇫🇴',
  flag_fr: '🇫🇷',
  france: '🇫🇷',
  flag_ga: '🇬🇦',
  gabon: '🇬🇦',
  flag_gb: '🇬🇧',
  uk: '🇬🇧',
  united_kingdom: '🇬🇧',
  flag_gd: '🇬🇩',
  grenada: '🇬🇩',
  flag_ge: '🇬🇪',
  georgia: '🇬🇪',
  flag_gf: '🇬🇫',
  french_guiana: '🇬🇫',
  flag_gg: '🇬🇬',
  guernsey: '🇬🇬',
  flag_gh: '🇬🇭',
  ghana: '🇬🇭',
  flag_gi: '🇬🇮',
  gibraltar: '🇬🇮',
  flag_gl: '🇬🇱',
  greenland: '🇬🇱',
  flag_gm: '🇬🇲',
  gambia: '🇬🇲',
  flag_gn: '🇬🇳',
  guinea: '🇬🇳',
  flag_gp: '🇬🇵',
  guadeloupe: '🇬🇵',
  equatorial_guinea: '🇬🇶',
  flag_gq: '🇬🇶',
  flag_gr: '🇬🇷',
  greece: '🇬🇷',
  flag_gs: '🇬🇸',
  south_georgia_south_sandwich_islands: '🇬🇸',
  flag_gt: '🇬🇹',
  guatemala: '🇬🇹',
  flag_gu: '🇬🇺',
  guam: '🇬🇺',
  flag_gw: '🇬🇼',
  guinea_bissau: '🇬🇼',
  flag_gy: '🇬🇾',
  guyana: '🇬🇾',
  flag_hk: '🇭🇰',
  hong_kong: '🇭🇰',
  flag_hm: '🇭🇲',
  heard_mcdonald_islands: '🇭🇲',
  flag_hn: '🇭🇳',
  honduras: '🇭🇳',
  croatia: '🇭🇷',
  flag_hr: '🇭🇷',
  flag_ht: '🇭🇹',
  haiti: '🇭🇹',
  flag_hu: '🇭🇺',
  hungary: '🇭🇺',
  canary_islands: '🇮🇨',
  flag_ic: '🇮🇨',
  flag_id: '🇮🇩',
  indonesia: '🇮🇩',
  flag_ie: '🇮🇪',
  ireland: '🇮🇪',
  flag_il: '🇮🇱',
  israel: '🇮🇱',
  flag_im: '🇮🇲',
  isle_of_man: '🇮🇲',
  flag_in: '🇮🇳',
  india: '🇮🇳',
  british_indian_ocean_territory: '🇮🇴',
  flag_io: '🇮🇴',
  flag_iq: '🇮🇶',
  iraq: '🇮🇶',
  flag_ir: '🇮🇷',
  iran: '🇮🇷',
  flag_is: '🇮🇸',
  iceland: '🇮🇸',
  flag_it: '🇮🇹',
  italy: '🇮🇹',
  flag_je: '🇯🇪',
  jersey: '🇯🇪',
  flag_jm: '🇯🇲',
  jamaica: '🇯🇲',
  flag_jo: '🇯🇴',
  jordan: '🇯🇴',
  flag_jp: '🇯🇵',
  japan: '🇯🇵',
  flag_ke: '🇰🇪',
  kenya: '🇰🇪',
  flag_kg: '🇰🇬',
  kyrgyzstan: '🇰🇬',
  cambodia: '🇰🇭',
  flag_kh: '🇰🇭',
  flag_ki: '🇰🇮',
  kiribati: '🇰🇮',
  comoros: '🇰🇲',
  flag_km: '🇰🇲',
  flag_kn: '🇰🇳',
  st_kitts_nevis: '🇰🇳',
  flag_kp: '🇰🇵',
  north_korea: '🇰🇵',
  flag_kr: '🇰🇷',
  south_korea: '🇰🇷',
  flag_kw: '🇰🇼',
  kuwait: '🇰🇼',
  cayman_islands: '🇰🇾',
  flag_ky: '🇰🇾',
  flag_kz: '🇰🇿',
  kazakhstan: '🇰🇿',
  flag_la: '🇱🇦',
  laos: '🇱🇦',
  flag_lb: '🇱🇧',
  lebanon: '🇱🇧',
  flag_lc: '🇱🇨',
  st_lucia: '🇱🇨',
  flag_li: '🇱🇮',
  liechtenstein: '🇱🇮',
  flag_lk: '🇱🇰',
  sri_lanka: '🇱🇰',
  flag_lr: '🇱🇷',
  liberia: '🇱🇷',
  flag_ls: '🇱🇸',
  lesotho: '🇱🇸',
  flag_lt: '🇱🇹',
  lithuania: '🇱🇹',
  flag_lu: '🇱🇺',
  luxembourg: '🇱🇺',
  flag_lv: '🇱🇻',
  latvia: '🇱🇻',
  flag_ly: '🇱🇾',
  libya: '🇱🇾',
  flag_ma: '🇲🇦',
  morocco: '🇲🇦',
  flag_mc: '🇲🇨',
  monaco: '🇲🇨',
  flag_md: '🇲🇩',
  moldova: '🇲🇩',
  flag_me: '🇲🇪',
  montenegro: '🇲🇪',
  flag_mf: '🇲🇫',
  st_martin: '🇲🇫',
  flag_mg: '🇲🇬',
  madagascar: '🇲🇬',
  flag_mh: '🇲🇭',
  marshall_islands: '🇲🇭',
  flag_mk: '🇲🇰',
  macedonia: '🇲🇰',
  flag_ml: '🇲🇱',
  mali: '🇲🇱',
  burma: '🇲🇲',
  flag_mm: '🇲🇲',
  myanmar: '🇲🇲',
  flag_mn: '🇲🇳',
  mongolia: '🇲🇳',
  flag_mo: '🇲🇴',
  macao: '🇲🇴',
  macau: '🇲🇴',
  flag_mp: '🇲🇵',
  northern_mariana_islands: '🇲🇵',
  flag_mq: '🇲🇶',
  martinique: '🇲🇶',
  flag_mr: '🇲🇷',
  mauritania: '🇲🇷',
  flag_ms: '🇲🇸',
  montserrat: '🇲🇸',
  flag_mt: '🇲🇹',
  malta: '🇲🇹',
  flag_mu: '🇲🇺',
  mauritius: '🇲🇺',
  flag_mv: '🇲🇻',
  maldives: '🇲🇻',
  flag_mw: '🇲🇼',
  malawi: '🇲🇼',
  flag_mx: '🇲🇽',
  mexico: '🇲🇽',
  flag_my: '🇲🇾',
  malaysia: '🇲🇾',
  flag_mz: '🇲🇿',
  mozambique: '🇲🇿',
  flag_na: '🇳🇦',
  namibia: '🇳🇦',
  flag_nc: '🇳🇨',
  new_caledonia: '🇳🇨',
  flag_ne: '🇳🇪',
  niger: '🇳🇪',
  flag_nf: '🇳🇫',
  norfolk_island: '🇳🇫',
  flag_ng: '🇳🇬',
  nigeria: '🇳🇬',
  flag_ni: '🇳🇮',
  nicaragua: '🇳🇮',
  flag_nl: '🇳🇱',
  netherlands: '🇳🇱',
  flag_no: '🇳🇴',
  norway: '🇳🇴',
  flag_np: '🇳🇵',
  nepal: '🇳🇵',
  flag_nr: '🇳🇷',
  nauru: '🇳🇷',
  flag_nu: '🇳🇺',
  niue: '🇳🇺',
  flag_nz: '🇳🇿',
  new_zealand: '🇳🇿',
  flag_om: '🇴🇲',
  oman: '🇴🇲',
  flag_pa: '🇵🇦',
  panama: '🇵🇦',
  flag_pe: '🇵🇪',
  peru: '🇵🇪',
  flag_pf: '🇵🇫',
  french_polynesia: '🇵🇫',
  flag_pg: '🇵🇬',
  papua_new_guinea: '🇵🇬',
  flag_ph: '🇵🇭',
  philippines: '🇵🇭',
  flag_pk: '🇵🇰',
  pakistan: '🇵🇰',
  flag_pl: '🇵🇱',
  poland: '🇵🇱',
  flag_pm: '🇵🇲',
  st_pierre_miquelon: '🇵🇲',
  flag_pn: '🇵🇳',
  pitcairn_islands: '🇵🇳',
  flag_pr: '🇵🇷',
  puerto_rico: '🇵🇷',
  flag_ps: '🇵🇸',
  palestinian_territories: '🇵🇸',
  flag_pt: '🇵🇹',
  portugal: '🇵🇹',
  flag_pw: '🇵🇼',
  palau: '🇵🇼',
  flag_py: '🇵🇾',
  paraguay: '🇵🇾',
  flag_qa: '🇶🇦',
  qatar: '🇶🇦',
  flag_re: '🇷🇪',
  reunion: '🇷🇪',
  flag_ro: '🇷🇴',
  romania: '🇷🇴',
  flag_rs: '🇷🇸',
  serbia: '🇷🇸',
  flag_ru: '🇷🇺',
  russia: '🇷🇺',
  flag_rw: '🇷🇼',
  rwanda: '🇷🇼',
  flag_sa: '🇸🇦',
  saudi_arabia: '🇸🇦',
  flag_sb: '🇸🇧',
  solomon_islands: '🇸🇧',
  flag_sc: '🇸🇨',
  seychelles: '🇸🇨',
  flag_sd: '🇸🇩',
  sudan: '🇸🇩',
  flag_se: '🇸🇪',
  sweden: '🇸🇪',
  flag_sg: '🇸🇬',
  singapore: '🇸🇬',
  flag_sh: '🇸🇭',
  st_helena: '🇸🇭',
  flag_si: '🇸🇮',
  slovenia: '🇸🇮',
  flag_sj: '🇸🇯',
  svalbard_jan_mayen: '🇸🇯',
  flag_sk: '🇸🇰',
  slovakia: '🇸🇰',
  flag_sl: '🇸🇱',
  sierra_leone: '🇸🇱',
  flag_sm: '🇸🇲',
  san_marino: '🇸🇲',
  flag_sn: '🇸🇳',
  senegal: '🇸🇳',
  flag_so: '🇸🇴',
  somalia: '🇸🇴',
  flag_sr: '🇸🇷',
  suriname: '🇸🇷',
  flag_ss: '🇸🇸',
  south_sudan: '🇸🇸',
  flag_st: '🇸🇹',
  sao_tome_principe: '🇸🇹',
  el_salvador: '🇸🇻',
  flag_sv: '🇸🇻',
  flag_sx: '🇸🇽',
  sint_maarten: '🇸🇽',
  flag_sy: '🇸🇾',
  syria: '🇸🇾',
  eswatini: '🇸🇿',
  flag_sz: '🇸🇿',
  swaziland: '🇸🇿',
  flag_ta: '🇹🇦',
  tristan_da_cunha: '🇹🇦',
  flag_tc: '🇹🇨',
  turks_caicos_islands: '🇹🇨',
  chad: '🇹🇩',
  flag_td: '🇹🇩',
  flag_tf: '🇹🇫',
  french_southern_territories: '🇹🇫',
  flag_tg: '🇹🇬',
  togo: '🇹🇬',
  flag_th: '🇹🇭',
  thailand: '🇹🇭',
  flag_tj: '🇹🇯',
  tajikistan: '🇹🇯',
  flag_tk: '🇹🇰',
  tokelau: '🇹🇰',
  flag_tl: '🇹🇱',
  timor_leste: '🇹🇱',
  flag_tm: '🇹🇲',
  turkmenistan: '🇹🇲',
  flag_tn: '🇹🇳',
  tunisia: '🇹🇳',
  flag_to: '🇹🇴',
  tonga: '🇹🇴',
  flag_tr: '🇹🇷',
  turkey_tr: '🇹🇷',
  flag_tt: '🇹🇹',
  trinidad_tobago: '🇹🇹',
  flag_tv: '🇹🇻',
  tuvalu: '🇹🇻',
  flag_tw: '🇹🇼',
  taiwan: '🇹🇼',
  flag_tz: '🇹🇿',
  tanzania: '🇹🇿',
  flag_ua: '🇺🇦',
  ukraine: '🇺🇦',
  flag_ug: '🇺🇬',
  uganda: '🇺🇬',
  flag_um: '🇺🇲',
  us_outlying_islands: '🇺🇲',
  flag_un: '🇺🇳',
  un: '🇺🇳',
  united_nations: '🇺🇳',
  flag_us: '🇺🇸',
  united_states: '🇺🇸',
  usa: '🇺🇸',
  flag_uy: '🇺🇾',
  uruguay: '🇺🇾',
  flag_uz: '🇺🇿',
  uzbekistan: '🇺🇿',
  flag_va: '🇻🇦',
  vatican_city: '🇻🇦',
  flag_vc: '🇻🇨',
  st_vincent_grenadines: '🇻🇨',
  flag_ve: '🇻🇪',
  venezuela: '🇻🇪',
  british_virgin_islands: '🇻🇬',
  flag_vg: '🇻🇬',
  flag_vi: '🇻🇮',
  us_virgin_islands: '🇻🇮',
  flag_vn: '🇻🇳',
  vietnam: '🇻🇳',
  flag_vu: '🇻🇺',
  vanuatu: '🇻🇺',
  flag_wf: '🇼🇫',
  wallis_futuna: '🇼🇫',
  flag_ws: '🇼🇸',
  samoa: '🇼🇸',
  flag_xk: '🇽🇰',
  kosovo: '🇽🇰',
  flag_ye: '🇾🇪',
  yemen: '🇾🇪',
  flag_yt: '🇾🇹',
  mayotte: '🇾🇹',
  flag_za: '🇿🇦',
  south_africa: '🇿🇦',
  flag_zm: '🇿🇲',
  zambia: '🇿🇲',
  flag_zw: '🇿🇼',
  zimbabwe: '🇿🇼',
  england: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  flag_gbeng: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  flag_gbsct: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  scotland: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  flag_gbwls: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  wales: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  smiling_face_with_three_hearts: '🥰',
  hugs: '🤗',
  face_with_open_eyes_and_hand_over_mouth: '🫢',
  face_in_clouds: '😶‍🌫️',
  roll_eyes: '🙄',
  face_exhaling: '😮‍💨',
  vomiting_face: '🤮',
  face_with_spiral_eyes: '😵‍💫',
  cowboy_hat_face: '🤠',
  monocle_face: '🧐',
  cursing_face: '🤬',
  hankey: '💩',
  crying_cat_face: '😿',
  heavy_heart_exclamation: '❣️',
  eye_speech_bubble: '👁️‍🗨️',
  hand: '✋',
  vulcan_salute: '🖖',
  palm_down_hand: '🫳',
  palm_up_hand: '🫴',
  crossed_fingers: '🤞',
  fu: '🖕',
  index_pointing_at_the_viewer: '🫵',
  fist_raised: '✊',
  fist_oncoming: '👊',
  facepunch: '👊',
  fist_left: '🤛',
  fist_right: '🤜',
  blond_haired_person: '👱',
  bearded_person: '🧔',
  man_beard: '🧔‍♂️',
  woman_beard: '🧔‍♀️',
  red_haired_man: '👨‍🦰',
  curly_haired_man: '👨‍🦱',
  white_haired_man: '👨‍🦳',
  bald_man: '👨‍🦲',
  red_haired_woman: '👩‍🦰',
  person_red_hair: '🧑‍🦰',
  curly_haired_woman: '👩‍🦱',
  person_curly_hair: '🧑‍🦱',
  white_haired_woman: '👩‍🦳',
  person_white_hair: '🧑‍🦳',
  bald_woman: '👩‍🦲',
  person_bald: '🧑‍🦲',
  blond_haired_woman: '👱‍♀️',
  blonde_woman: '👱‍♀️',
  blond_haired_man: '👱‍♂️',
  frowning_person: '🙍',
  frowning_man: '🙍‍♂️',
  frowning_woman: '🙍‍♀️',
  pouting_man: '🙎‍♂️',
  pouting_woman: '🙎‍♀️',
  no_good_man: '🙅‍♂️',
  ng_man: '🙅‍♂️',
  no_good_woman: '🙅‍♀️',
  ng_woman: '🙅‍♀️',
  ok_person: '🙆',
  ok_man: '🙆‍♂️',
  ok_woman: '🙆‍♀️',
  tipping_hand_person: '💁',
  information_desk_person: '💁',
  tipping_hand_man: '💁‍♂️',
  sassy_man: '💁‍♂️',
  tipping_hand_woman: '💁‍♀️',
  sassy_woman: '💁‍♀️',
  raising_hand: '🙋',
  raising_hand_man: '🙋‍♂️',
  raising_hand_woman: '🙋‍♀️',
  bowing_man: '🙇‍♂️',
  bowing_woman: '🙇‍♀️',
  policeman: '👮‍♂️',
  policewoman: '👮‍♀️',
  male_detective: '🕵️‍♂️',
  female_detective: '🕵️‍♀️',
  guardsman: '💂‍♂️',
  guardswoman: '💂‍♀️',
  construction_worker_man: '👷‍♂️',
  construction_worker_woman: '👷‍♀️',
  person_with_turban: '👳',
  man_with_turban: '👳‍♂️',
  woman_with_turban: '👳‍♀️',
  man_with_gua_pi_mao: '👲',
  bride_with_veil: '👰‍♀️',
  superhero_man: '🦸‍♂️',
  superhero_woman: '🦸‍♀️',
  supervillain_man: '🦹‍♂️',
  supervillain_woman: '🦹‍♀️',
  mage_man: '🧙‍♂️',
  mage_woman: '🧙‍♀️',
  fairy_man: '🧚‍♂️',
  fairy_woman: '🧚‍♀️',
  vampire_man: '🧛‍♂️',
  vampire_woman: '🧛‍♀️',
  elf_man: '🧝‍♂️',
  elf_woman: '🧝‍♀️',
  genie_man: '🧞‍♂️',
  genie_woman: '🧞‍♀️',
  zombie_man: '🧟‍♂️',
  zombie_woman: '🧟‍♀️',
  massage_man: '💆‍♂️',
  massage_woman: '💆‍♀️',
  haircut_man: '💇‍♂️',
  haircut_woman: '💇‍♀️',
  walking_man: '🚶‍♂️',
  walking_woman: '🚶‍♀️',
  standing_person: '🧍',
  standing_man: '🧍‍♂️',
  standing_woman: '🧍‍♀️',
  kneeling_person: '🧎',
  kneeling_man: '🧎‍♂️',
  kneeling_woman: '🧎‍♀️',
  runner: '🏃',
  running_man: '🏃‍♂️',
  running_woman: '🏃‍♀️',
  business_suit_levitating: '🕴️',
  dancing_men: '👯‍♂️',
  dancing_women: '👯‍♀️',
  sauna_person: '🧖',
  sauna_man: '🧖‍♂️',
  sauna_woman: '🧖‍♀️',
  climbing_man: '🧗‍♂️',
  climbing_woman: '🧗‍♀️',
  golfing_man: '🏌️‍♂️',
  golfing_woman: '🏌️‍♀️',
  surfing_man: '🏄‍♂️',
  surfing_woman: '🏄‍♀️',
  rowing_man: '🚣‍♂️',
  rowing_woman: '🚣‍♀️',
  swimming_man: '🏊‍♂️',
  swimming_woman: '🏊‍♀️',
  bouncing_ball_person: '⛹️',
  bouncing_ball_man: '⛹️‍♂️',
  basketball_man: '⛹️‍♂️',
  bouncing_ball_woman: '⛹️‍♀️',
  basketball_woman: '⛹️‍♀️',
  weight_lifting_man: '🏋️‍♂️',
  weight_lifting_woman: '🏋️‍♀️',
  biking_man: '🚴‍♂️',
  biking_woman: '🚴‍♀️',
  mountain_biking_man: '🚵‍♂️',
  mountain_biking_woman: '🚵‍♀️',
  handball_person: '🤾',
  juggling_person: '🤹',
  lotus_position: '🧘',
  lotus_position_man: '🧘‍♂️',
  lotus_position_woman: '🧘‍♀️',
  sleeping_bed: '🛌',
  couplekiss_man_woman: '👩‍❤️‍💋‍👨',
  couplekiss_man_man: '👨‍❤️‍💋‍👨',
  couplekiss_woman_woman: '👩‍❤️‍💋‍👩',
  couple_with_heart_woman_man: '👩‍❤️‍👨',
  couple_with_heart_man_man: '👨‍❤️‍👨',
  couple_with_heart_woman_woman: '👩‍❤️‍👩',
  family_man_woman_boy: '👨‍👩‍👦',
  family_man_woman_girl: '👨‍👩‍👧',
  family_man_woman_girl_boy: '👨‍👩‍👧‍👦',
  family_man_woman_boy_boy: '👨‍👩‍👦‍👦',
  family_man_woman_girl_girl: '👨‍👩‍👧‍👧',
  family_man_man_boy: '👨‍👨‍👦',
  family_man_man_girl: '👨‍👨‍👧',
  family_man_man_girl_boy: '👨‍👨‍👧‍👦',
  family_man_man_boy_boy: '👨‍👨‍👦‍👦',
  family_man_man_girl_girl: '👨‍👨‍👧‍👧',
  family_woman_woman_boy: '👩‍👩‍👦',
  family_woman_woman_girl: '👩‍👩‍👧',
  family_woman_woman_girl_boy: '👩‍👩‍👧‍👦',
  family_woman_woman_boy_boy: '👩‍👩‍👦‍👦',
  family_woman_woman_girl_girl: '👩‍👩‍👧‍👧',
  family_man_boy: '👨‍👦',
  family_man_boy_boy: '👨‍👦‍👦',
  family_man_girl: '👨‍👧',
  family_man_girl_boy: '👨‍👧‍👦',
  family_man_girl_girl: '👨‍👧‍👧',
  family_woman_boy: '👩‍👦',
  family_woman_boy_boy: '👩‍👦‍👦',
  family_woman_girl: '👩‍👧',
  family_woman_girl_boy: '👩‍👧‍👦',
  family_woman_girl_girl: '👩‍👧‍👧',
  dog2: '🐕',
  cat2: '🐈',
  tiger2: '🐅',
  cow2: '🐄',
  pig2: '🐖',
  hippopotamus: '🦛',
  mouse2: '🐁',
  rabbit2: '🐇',
  feet: '🐾',
  whale2: '🐋',
  flipper: '🐬',
  honeybee: '🐝',
  mandarin: '🍊',
  kiwi_fruit: '🥝',
  ginger_root: '🫚',
  pea_pod: '🫛',
  milk_glass: '🥛',
  plate_with_cutlery: '🍽️',
  hocho: '🔪',
  train2: '🚆',
  kick_scooter: '🛴',
  boat: '⛵',
  motor_boat: '🛥️',
  flight_departure: '🛫',
  flight_arrival: '🛬',
  artificial_satellite: '🛰️',
  bellhop_bell: '🛎️',
  mantelpiece_clock: '🕰️',
  moon: '🌔',
  cloud_with_lightning_and_rain: '⛈️',
  wind_face: '🌬️',
  open_umbrella: '☂️',
  parasol_on_ground: '⛱️',
  snowman_with_snow: '☃️',
  medal_military: '🎖️',
  medal_sports: '🏅',
  '1st_place_medal': '🥇',
  '2nd_place_medal': '🥈',
  '3rd_place_medal': '🥉',
  ice_hockey: '🏒',
  dark_sunglasses: '🕶️',
  tshirt: '👕',
  swim_brief: '🩲',
  folding_hand_fan: '🪭',
  shopping: '🛍️',
  shoe: '👞',
  phone: '☎️',
  film_strip: '🎞️',
  camera_flash: '📸',
  lantern: '🏮',
  newspaper_roll: '🗞️',
  pencil2: '✏️',
  spiral_notepad: '🗒️',
  spiral_calendar: '🗓️',
  balance_scale: '⚖️',
  x_ray: '🩻',
  identification_card: '🪪',
  next_track_button: '⏭️',
  play_or_pause_button: '⏯️',
  previous_track_button: '⏮️',
  pause_button: '⏸️',
  stop_button: '⏹️',
  record_button: '⏺️',
  eject_button: '⏏️',
  heavy_multiplication_x: '✖️',
  heavy_plus_sign: '➕',
  heavy_minus_sign: '➖',
  heavy_division_sign: '➗',
  grey_question: '❔',
  grey_exclamation: '❕',
  heavy_exclamation_mark: '❗',
  fleur_de_lis: '⚜️',
  keycap_ten: '🔟',
  o2: '🅾️',
  sa: '🈂️',
  u6e80: '🈵',
  large_blue_circle: '🔵',
  cn: '🇨🇳',
  de: '🇩🇪',
  es: '🇪🇸',
  eu: '🇪🇺',
  fr: '🇫🇷',
  gb: '🇬🇧',
  it: '🇮🇹',
  jp: '🇯🇵',
  kr: '🇰🇷',
  ru: '🇷🇺',
  tr: '🇹🇷',
  us: '🇺🇸',
}
